<template>
  <div class="tenancy-view-info-wrapper">
    <div class="row">
      <div class="small-12 medium-12 large-12 columns contact-column">
        <div class="column-content">
          <div class="contact-section">
            <div class="confirm-box">
              <TenantConfirm />
              <div class="confirm-box__row">
                <div class="confirm-message float-left text-left">
                  <span class="last-confirm last-confirm__text">{{ lastUpdateOrConfirmText }}</span>
                </div>
                <div
                  v-if="showConfirmBtn"
                  class="confirm-btn float-left text-left"
                >
                  <TenantConfirmModal ref="TenantConfirmModalRef" />
                  <button
                    class="btn btn--orange"
                    @click="$refs.TenantConfirmModalRef.open()"
                  >
                    {{ $t('tenancy.confirmContact') }}
                  </button>
                </div>
                <div class="change-history float-right text-right">
                  <a
                    class="all-ecircular-link"
                    @click="$refs.historiesModal.open()"
                  >
                    {{ $t('tenancy.changeHistory') }}
                  </a>
                </div>
              </div>
            </div>
            <div class="contact-section-header clearboth">
              <span class="contact-section-header">{{ $t('tenancy.table.eCircularContacts') }}</span>
              <div
                v-if="canReadEcircular"
                class="float-right text-right"
              >
                <a
                  class="all-ecircular-link"
                  @click="goToAllECircularPage"
                >
                  {{ $t('eCircular.viewAll') }}
                </a>
              </div>
            </div>
            <table class="contacts-table">
              <thead>
                <tr class="table-header-height">
                  <th
                    v-for="(header, index) in eCircluarHeaders"
                    :key="index"
                    :class="header.class"
                  >
                    {{ header.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in circleContacts"
                  :key="index"
                  class="table-body-row__height"
                  :class="{'expired': item.isExpired}"
                >
                  <td class="select-column">
                    <input
                      v-hkldinput
                      class="primary-radio-button"
                      type="radio"
                      name="primaryPerson"
                      :disabled="true"
                      :checked="deep(item, 'CompanyContact.cPrimary')"
                    >
                  </td>
                  <td class="number-column">
                    <div v-if="canAccessContact">
                      <a
                        class="name-hyper-link"
                        @click="navToContactDetail(item.id, false)"
                      >
                        {{ displayI18nFullName(item.firstName, item.lastName)|| item.name }}
                      </a>
                      <i
                        v-if="isEngineer"
                        v-show="!!item.remarks"
                        class="remark-included-flag"
                      />
                    </div>
                    <div v-else>
                      {{ displayI18nFullName(item.firstName, item.lastName)|| item.name }}
                    </div>
                  </td>
                  <td class="number-column">
                    <div> {{ item.phone | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div> {{ deep(item, 'CompanyContact.cEmails').join(', ') | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div class="">
                      {{ (deep(item, 'CompanyContact.cFloor') || []).join(', ') | isEmptyValue }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="contact-section">
            <p class="contact-section-header">
              {{ $t('tenancy.emergencyDuringOfficeHours') }}
            </p>
            <table class="contacts-table">
              <thead>
                <tr class="table-header-height">
                  <th
                    v-for="(header, index) in emergencyHeaders"
                    :key="index"
                    :class="header.class"
                  >
                    {{ header.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in emergencyWorkingContacts"
                  :key="index"
                  class="table-body-row__height"
                >
                  <td class="select-column">
                    <div>{{ ordinalNumber(deep(item, 'CompanyContact.workingHourOrder')) | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div v-if="canAccessContact">
                      <a
                        class="name-hyper-link"
                        @click="navToContactDetail(item.id, false)"
                      >
                        {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                      </a>
                      <i
                        v-if="isEngineer"
                        v-show="!!item.remarks"
                        class="remark-included-flag"
                      />
                    </div>
                    <div v-else>
                      {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                    </div>
                  </td>
                  <td class="number-column">
                    <div>{{ getAllPhones(item) }}</div>
                  </td>
                  <td class="number-column">
                    <div>{{ item.email | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div>
                      <pre>{{ deep(item, 'CompanyContact.oRemarks') | isEmptyValue }}</pre>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="contact-section">
            <p class="contact-section-header">
              {{ $t('tenancy.emergencyAfterOfficeHours') }}
            </p>
            <table class="contacts-table">
              <thead>
                <tr class="table-header-height">
                  <th
                    v-for="(header, index) in emergencyHeaders"
                    :key="index"
                    :class="header.class"
                  >
                    {{ header.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in emergencyNonWorkingContacts"
                  :key="index"
                  class="table-body-row__height"
                >
                  <td class="select-column">
                    <div> {{ ordinalNumber(deep(item, 'CompanyContact.nonWorkingHourOrder')) | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div v-if="canAccessContact">
                      <a
                        class="name-hyper-link"
                        @click="navToContactDetail(item.id, false)"
                      >
                        {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                      </a>
                      <i
                        v-if="isEngineer"
                        v-show="!!item.remarks"
                        class="remark-included-flag"
                      />
                    </div>
                    <div v-else>
                      {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                    </div>
                  </td>
                  <td class="number-column">
                    <div> {{ getAllPhones(item) }}</div>
                  </td>
                  <td class="number-column">
                    <div> {{ item.email | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div>
                      <pre>{{ deep(item, 'CompanyContact.oRemarks') | isEmptyValue }}</pre>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <FireMarshalContact />
          <div v-if="isRetail">
            <div v-if="canEditMarketing && isRetail">
              <MarketingContact
                ref="marketingContact"
                :tenancyId="tenancyId"
                :allowLinkContacts="allowLinkContacts"
                :linkFunc="linkFunc"
              />
            </div>
            <div
              v-else
              class="contact-section"
            >
              <p class="contact-section-header">
                {{ $t('tenancy.table.marketing') }}
              </p>
              <table class="contacts-table">
                <thead>
                  <tr class="table-header-height">
                    <th
                      v-for="(header, index) in marketingHeaders"
                      :key="index"
                      :class="header.class"
                    >
                      {{ header.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in marketingContacts"
                    :key="index"
                    class="table-body-row__height"
                  >
                    <td class="number-column">
                      <div> {{ deep(item, 'CompanyContact.roleType').join(', ') | isEmptyValue }}</div>
                    </td>
                    <td class="number-column">
                      <div v-if="canAccessContact">
                        <a
                          class="name-hyper-link"
                          @click="navToContactDetail(item.id, false)"
                        >
                          {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                        </a>
                        <i
                          v-if="isEngineer"
                          v-show="!!item.remarks"
                          class="remark-included-flag"
                        />
                      </div>
                      <div v-else>
                        {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                      </div>
                    </td>
                    <td class="number-column">
                      <div> {{ item.phone | isEmptyValue }}</div>
                    </td>
                    <td class="number-column">
                      <div> {{ deep(item, 'CompanyContact.mEmails').join(', ') | isEmptyValue }}</div>
                    </td>
                    <td class="number-column">
                      <div>
                        <pre>{{ deep(item, 'CompanyContact.mRemarks') | isEmptyValue }}</pre>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="contact-section">
            <p class="contact-section-header">
              {{ $t('tenancy.table.allContacts') }}
            </p>
            <table class="contacts-table">
              <thead>
                <tr class="table-header-height">
                  <th
                    v-for="(header, index) in otherHeaders"
                    :key="index"
                    :class="header.class"
                  >
                    {{ header.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in otherContacts"
                  :key="index"
                  class="table-body-row__height"
                >
                  <td class="number-column">
                    <div v-if="canAccessContact">
                      <a
                        class="name-hyper-link"
                        @click="navToContactDetail(item.id, false)"
                      >
                        {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                      </a>
                      <i
                        v-if="isEngineer"
                        v-show="!!item.remarks"
                        class="remark-included-flag"
                      />
                    </div>
                    <div v-else>
                      {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                    </div>
                  </td>
                  <td class="number-column">
                    <div> {{ deep(item, 'CompanyContact.title') | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div> {{ item.phone | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div> {{ item.email | isEmptyValue }}</div>
                  </td>
                  <td class="number-column">
                    <div> {{ calcRoleType(item) }}</div>
                  </td>
                  <td class="number-column">
                    <template v-for="(mapItem, mapIndex) in remarksFieldMap">
                      <div
                        v-if="mapItem.shouldShow(item)"
                        :key="mapIndex"
                        :class="mapIndex"
                      >
                        <br v-if="mapIndex !== 'oRemarks'">
                        <pre>{{ mapItem.componentVal(item) | isEmptyValue }}</pre>
                      </div>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <TenancyHistoriesModal ref="historiesModal" />
  </div>
</template>

<script>
import lodash from 'lodash'
import { computed, unref } from 'vue-demi'
import { mapGetters } from 'vuex'
import MarketingContact from '@/modules/ccd/tenancy/edit/MarketingContact'
import navToContactDetailMixin from '@/modules/ccd/tenancy/edit/navToContactDetailMixin'
import TenantConfirm from '@/pages/ccd/TenantConfirm'
import TenantConfirmModal from '@/pages/ccd/TenantConfirmModal'
import formFullnameMixin from '@/pages/formFullnameMixin'
import { useStoreGetters } from '@/store/index'
import { aclHelper, ccdPermsTypes, tmsPermsTypes } from '@/utils/aclHelper'
import dateUtil from '@/utils/dateUtil'
import EventBus from '@/utils/eventBus'
import { tenancyType } from '@/utils/locale'
import navigation from '@/utils/navigation'
import ordinalUtils from '@/utils/ordinalUtils'
import { useTrContactTabRemarks } from '../hook'
import TenancyHistoriesModal from '../TenancyHistoriesModal'
import { calcContactRoleType } from '../utils'
import { DAY_TIME_FORMAT } from './const'
import FireMarshalContact from './FireMarshalContact.vue'

export default {
  name: 'TenancyAllContacts',
  components: {
    FireMarshalContact,
    TenantConfirm,
    TenancyHistoriesModal,
    TenantConfirmModal,
    MarketingContact,
  },
  mixins: [navToContactDetailMixin, formFullnameMixin],
  props: {
    tenancyId: {
      type: [String, Number],
      default: '',
    },
    canEditMarketing: {
      type: Boolean,
      default: false,
    },
    allowLinkContacts: Boolean,
    linkFunc: {
      type: Function,
      default: () => {},
    },
  },
  setup () {
    const { currentTenancy } = useStoreGetters('ccd', ['currentTenancy'])
    const isRetailTr = computed(() => {
      return unref(currentTenancy).type === tenancyType.Retail
    })
    const remarksFieldMap = useTrContactTabRemarks({
      isRetailTr,
    })
    return {
      currentTenancy,
      remarksFieldMap,
      calcRoleType: calcContactRoleType,
    }
  },
  data () {
    const eCircluarHeaders = [{
      name: this.$t('tenancy.table.primary'),
      class: 'column-primary',
    }, {
      name: this.$t('tenancy.table.name'),
      class: 'column-name',
    }, {
      name: this.$t('tenancy.table.priPhone'),
      class: 'column-phone',
    }, {
      name: this.$t('tenancy.table.ecEmail'),
      class: 'column-email',
    }, {
      name: this.$t('tenancy.table.floor'),
      class: 'column-floor',
    }]
    const emergencyHeaders = [{
      name: this.$t('tenancy.table.position'),
      class: 'workinghour-position column-position',
    }, {
      name: this.$t('tenancy.table.name'),
      class: 'column-name',
    }, {
      name: this.$t('general.phone'),
      class: 'column-phone',
    }, {
      name: this.$t('tenancy.table.priEmail'),
      class: 'column-email',
    }, {
      name: this.$t('tenancy.table.remarks'),
      class: 'column-remarks',
    }]
    const marketingHeaders = [{
      name: this.$t('company.contactTable.role'),
      class: 'column-primary',
    }, {
      name: this.$t('tenancy.table.name'),
      class: 'column-name',
    }, {
      name: this.$t('general.phone'),
      class: 'column-phone',
    }, {
      name: this.$t('general.email'),
      class: 'column-email',
    }, {
      name: this.$t('contact.remarks'),
      class: 'column-remarks',
    }]
    const otherHeaders = [{
      name: this.$t('tenancy.table.name'),
      class: 'column-name',
    }, {
      name: this.$t('company.contactTable.title'),
      class: 'column-title',
    }, {
      name: this.$t('tenancy.table.priPhone'),
      class: 'column-phone',
    }, {
      name: this.$t('tenancy.table.priEmail'),
      class: 'column-email',
    }, {
      name: this.$t('company.contactTable.roleType'),
      class: 'column-email',
    }, {
      name: this.$t('contact.remarks'),
      class: 'column-remarks',
    }]
    return {
      deep,
      eCircluarHeaders,
      emergencyHeaders,
      marketingHeaders,
      otherHeaders,
      DAY_TIME_FORMAT,
      histories: [],
    }
  },
  computed: {
    ...mapGetters('ccd', ['canTenantEditContact', 'contactViewTenants']),
    ...mapGetters('user', ['currentUser', 'isTenant', 'isEngineer']),
    expiredFloors () {
      return this.currentTenancy.premisesDetailList.reduce((result, item) => {
        if (!dateUtil.isEffective(item.effectiveDate, item.endDate)) {
          result.push(item.floor)
        }
        return result
      }, [])
    },
    circleContacts () {
      return (this.currentTenancy.tenancyContacts || [])
        .reduce((result, item) => {
          if (lodash.get(item, 'CompanyContact.isCircular')) {
            item.isExpired = item.CompanyContact.cFloor && item.CompanyContact.cFloor.every(floor => this.expiredFloors.includes(floor))
            result.push(item)
          }
          return result
        }, [])
        .map((item) => ({
          ...item,
          name: item.firstName && item.lastName ? this.displayI18nFullName(item.firstName, item.lastName) : item.name,
        }))
    },
    emergencyWorkingContacts () {
      let contacts = (this.currentTenancy.tenancyContacts || [])
        .filter(item => deep(item, 'CompanyContact.isEmergency') && lodash.get(item, 'CompanyContact.workingHourOrder'))
      contacts.sort((a, b) => a.CompanyContact.workingHourOrder - b.CompanyContact.workingHourOrder)
      return contacts
        .map((item) => ({
          ...item,
          name: item.firstName && item.lastName ? this.displayI18nFullName(item.firstName, item.lastName) : item.name,
        }))
    },
    emergencyNonWorkingContacts () {
      let contacts = (this.currentTenancy.tenancyContacts || [])
        .filter(item => deep(item, 'CompanyContact.isEmergency') && lodash.get(item, 'CompanyContact.nonWorkingHourOrder'))
      contacts.sort((a, b) => a.CompanyContact.nonWorkingHourOrder - b.CompanyContact.nonWorkingHourOrder)
      return contacts
        .map((item) => ({
          ...item,
          name: item.firstName && item.lastName ? this.displayI18nFullName(item.firstName, item.lastName) : item.name,
        }))
    },
    marketingContacts () {
      return (this.currentTenancy.tenancyContacts || []).filter(item => lodash.get(item, 'CompanyContact.isMarketing'))
        .map((item) => ({
          ...item,
          name: item.firstName && item.lastName ? this.displayI18nFullName(item.firstName, item.lastName) : item.name,
        }))
    },
    otherContacts () {
      return (this.currentTenancy.tenancyContacts || []).filter(item => lodash.get(item, 'CompanyContact.isOthers'))
        .map((item) => ({
          ...item,
          name: item.firstName && item.lastName ? this.displayI18nFullName(item.firstName, item.lastName) : item.name,
        }))
    },
    confirmInfo () {
      let name = lodash.get(this.currentTenancy, 'confirmor.displayName', '')
      const id = lodash.get(this.currentTenancy, 'confirmor.id', '')
      if (this.currentTenancy && this.currentTenancy.accounts) {
        const account = this.currentTenancy.accounts.find(account => account.id === id)
        if (account) name = this.displayI18nFullName(account.TenancyAccount.contactFirstName, account.TenancyAccount.contactLastName)
      }
      return {
        name,
        date: lodash.get(this.currentTenancy, 'confirmedAt', ''),
        i18n: 'lastConfirmedBy',
      }
    },
    updateInfo () {
      const orderedHistory = lodash.orderBy(this.histories, ['createdAt'], ['desc'])
      return {
        name: lodash.get(orderedHistory, '0.who.displayName', ''),
        date: lodash.get(orderedHistory, '0.createdAt', ''),
        i18n: 'lastUpdatedBy',
      }
    },
    lastUpdateOrConfirmText () {
      const srcName = this.confirmInfo.date > this.updateInfo.date ? 'confirmInfo' : 'updateInfo'
      const src = this[srcName]
      const date = src.date ? dateUtil.format(src.date, DAY_TIME_FORMAT) : ''
      return date ? this.$t(src.i18n, [src.name, date]) : ''
    },
    isRetail () {
      return this.currentTenancy.type === tenancyType.Retail
    },
    showConfirmBtn () {
      let result = false
      if (this.isTenant && this.canTenantEditContact) {
        result = true
      }
      if (this.isEngineer && aclHelper.getAccess(ccdPermsTypes.tenancy.linkContacts)) {
        result = true
      }
      return result
    },
    canReadEcircular () {
      // This part not consider ecircular module configuration, since this need more effort and in real prod env tenancy record and ecircular module all open.
      return aclHelper.getAccess(tmsPermsTypes.tenantEcircular.read) || this.isTenant
    },
  },
  mounted () {
    EventBus.$on('tenancy.contacts.updateHistories', (histories) => {
      this.histories = lodash.cloneDeep(histories)
    })
  },
  destroyed () {
    EventBus.$off('tenancy.contacts.updateHistories')
  },
  methods: {
    ordinalNumber (number) {
      return ordinalUtils.getOrdinalFor(Number(number), true)
    },
    goToAllECircularPage () {
      navigation.replacePage(this.isTenant ? 'tenantTenancyECirculars' : 'ccdTenancyECirculars', { id: this.currentTenancy.id })
    },
    getAllPhones (item) {
      return item.allPhones && item.allPhones.length > 0 ? item.allPhones.join(', ') : '--'
    },
  },
}
</script>

<style lang="scss">
@import '~styles/tender/view';
@import '~styles/components/tenancy-view-info';
</style>
<style lang="scss" scoped>
@import './tenancy-contacts';

.confirm-box {
  .confirm-message, .confirm-btn {
    width: 33%;
  }
  &__row {
    overflow: hidden;
  }
  .confirm-message {
    padding-top: 20px;
    .last-confirm__text {
      font-size: 12px
    }
  }
  .change-history {
    padding-top: 20px
  }

  .confirm-btn {
    text-align: center;
  }
}
.all-ecircular-link {
  text-decoration: underline;
  color: #0C3A58;
  font-size: 12px;
}
.u-padding-right-small {
  padding-right: 5px;
}

.contacts-list-item {
  display: flex;
  align-items: center;
}

.primary-radio-button {
  margin-bottom: 0;
  margin-left: 24px;
}

.name-hyper-link {
  text-decoration: underline;
  color: #0c3a58;
}

.remark-included-flag:before {
  content: "\F06A";
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  color: #0c3a58;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
</style>
